import styled, { css } from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';

export const Container = styled.div``;

export const SpinnerWrap = styled.div`
  width: 100%;
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Spinner = styled(AiOutlineLoading3Quarters)`
  animation: spinerAnimate 1.5s linear infinite;
`;

export const DescriptionContainer = styled.div`
  margin-top: 35px;
  padding: 24px 41px;
  background: #ffffff;
  border-radius: 8px;
`;

export const DescriptionTitle = styled.h1`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 37px;
  color: #0b29fb;

  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const DescriptionText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 25px;
  color: #7a7a7a;
  display: inline-block;
  max-width: 600px;

  @media (max-width: 600px) {
    text-align: center;
    font-size: 12px;
  }
`;

export const ConsultantData = styled.div`
  padding: 24px 24px 0;

  @media (max-width: 600px) {
    padding: 24px 18px 0;
  }
`;

export const ConsultantDataContainer = styled.div`
  margin-top: 16px;
  width: 505px;
  background: #ffffff;
  border-radius: 8px;
  padding-bottom: 24px;

  @media (max-width: 600px) {
    width: 100%;
  }
`;

type TableWrapProps = {
  showTour?: boolean;
};

export const TableWrap = styled.div<TableWrapProps>`
  position: relative;

  ${({ showTour }) =>
    showTour &&
    css`
      z-index: 1000;
      background-color: #f5f5f5;
      padding: 2px;
      border-radius: 8px;
    `}
`;

export const ContactContainer = styled.div`
  background-color: #2dfffe;
  min-width: 52px;
  min-height: 52px;
  width: 52px;
  height: 52px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ContactInfoWrap = styled.div`
  display: flex;
  align-items: normal;
  justify-content: space-between;
  margin-top: 16px;
`;

export const ContactInfo = styled.div``;

export const ContactName = styled.span`
  display: inline-flex;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 25px;
  color: #0b29fb;
`;

export const ContactPhone = styled.span`
  display: inline-flex;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 37px;
  color: #7a7a7a;
`;

export const ContactMail = styled.span`
  display: inline-flex;
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 37px;
  display: flex;
  align-items: center;
  text-decoration-line: underline;
  color: #0b29fb;
`;

export const ContactDetailWrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;

  @media (max-width: 600px) {
    flex-direction: column;
    gap: unset;
  }
`;

export const ContactDetail = styled(ContactPhone)`
  font-size: 14px;

  @media (max-width: 600px) {
    font-size: 12px;
    margin-top: -16px;
  }
`;

export const SocialMediasTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #2dfffe;
  border-radius: 0px;
`;

export const SocialMediaText = styled.span`
  font-family: 'Mangueira', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 25px;
  color: #0b29fb;

  @media (max-width: 600px) {
    text-align: center;
  }
`;

export const SocialMediaItems = styled.div`
  margin: 16px 0;
  display: flex;
  justify-content: center;
  gap: 24px;
  align-items: center;
`;

export const SocialMediaInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  background: #2dfffe;
`;

export const SocialMediaLink = styled.a`
  width: 42px;
  height: 42px;
  border: 2px solid #0b29fb;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  outline: none;
`;
